export const getId = (prefix = "") => {
  return Math.random().toString(36).substr(2, 9) + `${prefix}`;
};
